export const baseUrl = process.env.GATSBY_API_BASE_URL;
export const apiUrl = baseUrl + process.env.GATSBY_API_END_URL;
